'use client';
import e from 'prop-types';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const ToggleSwitchSize = {
    Standard: 'standard',
    Super: 'super',
    Mini: 'mini'
};
let c = {
    size: deprecatedProp(e.oneOf([
        ToggleSwitchSize.Standard,
        ToggleSwitchSize.Super,
        ToggleSwitchSize.Mini
    ]), 'Sizing is now handled automatically by standardMode/compactMode'),
    hideText: e.bool,
    activated: e.bool,
    onRequestActivatedChange: e.func,
    defaultActivated: e.bool
};
const ToggleSwitch = createComponent({
    displayName: 'ToggleSwitch',
    root: 'button',
    propTypes: c,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.toggleSwitch,
    propConfig: {
        derivedProps (e) {
            let { defaultActivated: t = !1, activated: r, onRequestActivatedChange: o } = e, [i, c] = useControllableValue({
                value: r,
                onChange: o || void 0,
                defaultValue: t,
                defaultOnChange: (e, ...t)=>{
                    let [r] = t;
                    e(r);
                }
            });
            return {
                activated: !!i,
                onRequestActivatedChange: c
            };
        },
        processProps (e, t) {
            let { activated: r, onRequestActivatedChange: o } = t;
            return _object_spread_props(_object_spread({}, e), {
                role: 'switch',
                'aria-checked': r,
                onClick: composeEventHandlersUtil(e.onClick, (e)=>{
                    o(!r, e);
                })
            });
        },
        classNames (e) {
            let t = new Set([
                'swan-vanilla-ignore',
                'swan-toggle-switch'
            ]), { hideText: r, size: o = ToggleSwitchSize.Standard } = e;
            return o === ToggleSwitchSize.Mini && t.add(`swan-toggle-switch-${o}`), o === ToggleSwitchSize.Super && t.add(`swan-toggle-switch-${o}`), r && t.add('swan-toggle-switch-hide-text'), t;
        }
    }
});

export { ToggleSwitch, ToggleSwitchSize };
